import { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

const Screen = ({
  header,
  subheader,
  children,
}: {
  header: string;
  subheader: ReactNode;
  children?: ReactNode;
}) => (
  <Box
    sx={{
      flex: 1,
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 3,
      mt: 3,
      mb: 5,
      '&>*': {
        width: '100%',
      },
      '&>form': {
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      },
    }}
  >
    <Box>
      <Typography variant="h3" sx={{ textAlign: 'center' }}>
        {header}
      </Typography>
      {subheader && (
        <Typography variant="body1" sx={{ mt: 1, textAlign: 'center' }}>
          {subheader}
        </Typography>
      )}
    </Box>
    {children}
  </Box>
);

export default Screen;
